export const taskCenter = {
  syrw: 'Задания для вас, награды — вам',
  zjlbt: 'Получайте бонусы USDT от BiKing без остановки',
  wdjj: 'Мои бонусы',
  rwsm: 'Описание заданий',
  rwlb: 'Список заданий',
  jljl: 'История наград',
  klq: 'Доступно к получению',
  flzm: 'Врата бонусов BiKing',
  dcjl: 'Достигните цели и получите USDT на всём пути',
  yjlq: 'Получить всё',
  lqcg: 'Получено успешно',
  wdl: 'Не авторизован',
  jxz: 'В процессе',
  ylq: 'Получено',
  rwjd: 'Прогресс задания',
  xsrw: 'Задания для новичков',
  hyrw: 'Фьючерсные задания',
  cjrz: 'Базовая верификация',
  gjrz: 'Расширенная верификация',
  scbbjy: 'Первая спот-сделка',
  schyjy: 'Первая фьючерсная сделка',
  sccz: 'Первое пополнение',
  schyhz: 'Первый перевод на фьючерсный счёт',
  jyl: 'Объём торгов',
  ylje: 'Сумма прибыли',
  ksje: 'Сумма убытка',
  dbkcbzj: 'Маржа на одну открытую позицию',
  rjl: 'Сумма депозита',
  dbczje: 'Сумма одного пополнения',
  rwxq: 'Детали задания'
}


// WEBPACK FOOTER //
// ./src/i18n/lang/task/ru.js